import { Reducer } from 'redux';
import { DbdsState, DbdsTypes } from './types';

const INITIAL_STATE: DbdsState = {
  dbdData: {
    id: '',
    serial: '',
    createdAt: '',
    updatedAt: '',
    DbdVersionRequests: [],
  },
  dbdsList: [],
  monitoringData: null,
  monitoringLoading: false,
  monitoringError: false,
  telemetryData: null,
  telemetryLoading: false,
  telemetryError: false,
  dbdVersionList: [],
  dbdVersionData: null,
  dbdVersionRequestList: null,
  versionUpdateList: [],
  error: false,
  loading: false,
};

const reducer: Reducer<DbdsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_DBDS
    case DbdsTypes.LIST_DBDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dbdsList: INITIAL_STATE.dbdsList,
      };
    case DbdsTypes.LIST_DBDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdsList: action.payload.dbdsList,
      };
    case DbdsTypes.LIST_DBDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dbdsList: INITIAL_STATE.dbdsList,
      };

    // CASES GET DBD MONITORING
    case DbdsTypes.GET_DBD_MONITORING_REQUEST:
      return {
        ...state,
        monitoringLoading: true,
        monitoringError: false,
      };
    case DbdsTypes.GET_DBD_MONITORING_SUCCESS:
      return {
        ...state,
        monitoringLoading: false,
        monitoringError: false,
        monitoringData: action.payload.monitoringData,
      };
    case DbdsTypes.GET_DBD_MONITORING_FAILURE:
      return {
        ...state,
        monitoringLoading: false,
        monitoringError: true,
      };

    // CASES GET DBD TELEMETRY
    case DbdsTypes.GET_DBD_TELEMETRY_REQUEST:
      return {
        ...state,
        telemetryLoading: true,
        telemetryError: false,
        telemetryData: INITIAL_STATE.telemetryData,
      };
    case DbdsTypes.GET_DBD_TELEMETRY_SUCCESS:
      return {
        ...state,
        telemetryLoading: false,
        telemetryError: false,
        telemetryData: action.payload.telemetryData,
      };
    case DbdsTypes.GET_DBD_TELEMETRY_FAILURE:
      return {
        ...state,
        telemetryLoading: false,
        telemetryError: true,
        telemetryData: INITIAL_STATE.telemetryData,
      };

    // CASES GET DBD
    case DbdsTypes.GET_DBD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dbdData: INITIAL_STATE.dbdData,
      };
    case DbdsTypes.GET_DBD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdData: action.payload.dbdData,
      };
    case DbdsTypes.GET_DBD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dbdData: INITIAL_STATE.dbdData,
      };

    // CASES DBD VERSION REQUEST LIST REQUEST
    case DbdsTypes.DBD_VERSION_REQUEST_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dbdVersionRequestList: INITIAL_STATE.dbdVersionRequestList,
      };
    case DbdsTypes.DBD_VERSION_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdVersionRequestList: action.payload.dbdVersionRequestList,
      };
    case DbdsTypes.DBD_VERSION_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dbdVersionRequestList: INITIAL_STATE.dbdVersionRequestList,
      };

    // CASES CREATE DBD
    case DbdsTypes.CREATE_DBD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dbdData: INITIAL_STATE.dbdData,
      };
    case DbdsTypes.CREATE_DBD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdData: action.payload.dbdData,
      };
    case DbdsTypes.CREATE_DBD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dbdData: INITIAL_STATE.dbdData,
      };

    // CASES UPDATE DBD
    case DbdsTypes.UPDATE_DBD_REQUEST:
      return { ...state, loading: true, error: false };
    case DbdsTypes.UPDATE_DBD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdData: action.payload.dbdData,
      };
    case DbdsTypes.UPDATE_DBD_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE DBD
    case DbdsTypes.DELETE_DBD_REQUEST:
      return { ...state, loading: true, error: false };
    case DbdsTypes.DELETE_DBD_SUCCESS:
      return { ...state, loading: false, error: false };
    case DbdsTypes.DELETE_DBD_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES REQUEST STATUS
    case DbdsTypes.REQUEST_STATUS_REQUEST:
      return { ...state, loading: true, error: false };
    case DbdsTypes.REQUEST_STATUS_SUCCESS:
      return { ...state, loading: false, error: false };
    case DbdsTypes.REQUEST_STATUS_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DBD VERSION LIST
    case DbdsTypes.GET_DBD_VERSION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dbdVersionList: INITIAL_STATE.dbdVersionList,
      };
    case DbdsTypes.GET_DBD_VERSION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdVersionList: action.payload.dbdVersionList,
      };
    case DbdsTypes.GET_DBD_VERSION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dbdVersionList: INITIAL_STATE.dbdVersionList,
      };

    // CASES DBD VERSION DATA
    case DbdsTypes.GET_DBD_VERSION_REQUEST:
      return { ...state, loading: true, error: false };
    case DbdsTypes.GET_DBD_VERSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdVersionData: action.payload.dbdVersionData,
      };
    case DbdsTypes.GET_DBD_VERSION_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES VERSION UPDATE REQUEST
    case DbdsTypes.VERSION_UPDATE_REQUEST_REQUEST:
      return { ...state, loading: true, error: false };
    case DbdsTypes.VERSION_UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case DbdsTypes.VERSION_UPDATE_REQUEST_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES CREATE MANY DBD
    case DbdsTypes.CREATE_MANY_DBD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        dbdsList: INITIAL_STATE.dbdsList,
      };
    case DbdsTypes.CREATE_MANY_DBD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dbdsList: action.payload.dbdsList,
      };
    case DbdsTypes.CREATE_MANY_DBD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dbdsList: INITIAL_STATE.dbdsList,
      };

    default:
      return state;
  }
};

export default reducer;
